import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 26717 24744"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#252422}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M13359 18578c-4205 0-7626-3421-7626-7625 0-4205 3421-7626 7626-7626s7625 3421 7625 7626c0 4204-3420 7625-7625 7625zm0-15883c-4553 0-8257 3705-8257 8258 0 4552 3704 8256 8257 8256 4552 0 8257-3704 8257-8256 0-4553-3705-8258-8257-8258z"
        className="fil0"
      />
      <path
        d="M13359 15911c-2734 0-4958-2225-4958-4958 0-2735 2224-4959 4958-4959s4958 2224 4958 4959c0 2733-2224 4958-4958 4958zm0-10549c-3083 0-5590 2508-5590 5591 0 3082 2507 5589 5590 5589 3082 0 5589-2507 5589-5589 0-3083-2507-5590-5589-5591zM26086 23212c0 492-365 895-812 899h-8c-214 0-417-90-572-255-176-188-265-450-244-718l614-8049c45-582-186-1162-618-1555-599-671-913-1895-913-2764V6851c0-2344 928-4565 2553-6124v22485zM26375 47c-203-88-431-50-595 101-1830 1683-2879 4125-2879 6703l1 3919c0 964 340 2377 1087 3200l24 24c294 263 452 654 422 1047l-615 8049c-34 444 117 881 413 1197 275 295 641 456 1033 456h13c793-8 1438-694 1438-1531V581c0-233-134-443-342-534zM3813 7598l-462 497c-370 397-564 901-547 1420l446 13877c9 295-204 566-531 672-194 63-399 63-594 0-327-106-540-377-530-672l446-13877c16-519-178-1023-547-1420l-463-497c-279-301-421-679-397-1064l366-5902h512v5852h631V632h558v5852h632V632h512l365 5902c24 385-117 763-397 1064zm1028-1103L4438 0H407L4 6495c-35 560 166 1105 565 1534l463 497c254 273 389 618 378 969L964 23371c-19 578 369 1099 965 1294 161 52 327 79 493 79s332-27 494-79c596-195 983-716 965-1294L3435 9495c-12-351 123-696 378-969l462-498c399-428 600-973 566-1533z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
